import { render, staticRenderFns } from "./Nova.vue?vue&type=template&id=543f7249&scoped=true&"
import script from "./Nova.vue?vue&type=script&lang=js&"
export * from "./Nova.vue?vue&type=script&lang=js&"
import style0 from "./Nova.vue?vue&type=style&index=0&id=543f7249&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543f7249",
  null
  
)

export default component.exports